// Единственный QueryClient на вкладку.
//
// Вынесен из App.tsx, потому что смена workspace обязана сбрасывать кэш: данные
// в нём принадлежат прошлому workspace, и показывать их после переключения —
// это утечка чужого контекста в UI. Store переключения импортирует клиент
// отсюда, а App просто отдаёт его в провайдер.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
